











































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import BasicInformation from "./PosterEdit/BasicInformation.vue";
import PosterSet from "./PosterEdit/PosterSet.vue";
import AdvancedSettings from "./PosterEdit/AdvancedSettings.vue";
import NotificationSettings from "./PosterEdit/NotificationSettings.vue";
import MissionRewards from "./PosterEdit/MissionRewards.vue";
import PrizeVerification from "./PosterEdit/PrizeVerification.vue";
import Bus from "@/JS/Bus";
import httpApi from "@/API/Tenant/Weixin";
import { getCookie, delCookie, setCookie } from "@/JS/cookie"; //使用getCookie方法
@Component({
  components: {
    BasicInformation,
    PosterSet,
    AdvancedSettings,
    NotificationSettings,
    MissionRewards,
    PrizeVerification
  }
})
export default class extends Vue {
  //$message: any;
  //注入数据 @Provide()
  @Prop() private WxQrCodePosterList!: any;
  @Prop() private page!: any;
  @Prop() private WxQrCodePosterDetail!: any;
  @Prop()
  @Provide()
  private scrollHeight = 500; //当前高度
  private GetAppData: any = {}; //当前应用号信息
  private isEditPoster = false; //是否跳到编辑页
  private buttonDisplay = true;
  private loading = false;
  private posterInfo: any = {};
  private BasicInformationData: any = {
    eventName: "",
    group: "",
    keyWords: "",
    reward: true,
    labelDisplay: true,
    label: "",
    activityTime: "",
    //海报有效期
    expirationDate: { day: 10, hour: 0, minute: 0 }
  }; //活动基本信息
  private canvasBgImg: any; //背景图片
  private Effect: any; //海报效果图片
  private posterSetData: any; //海报设置
  private AdvancedSettingsData: any; //高级设置
  private notificationSettingsData: any; //通知设置
  // private PosterId: any;
  private activeName = "first"; //默认选项卡
  //private infoData: any; //父级页面传来的修改值
  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    var _this = this;

    //console.log(this.WxQrCodePosterList);
    //console.log(this.posterInfo);
    // let expireDays = 1000 * 60 * 60;
    // if (this.posterInfo) {
    //   console.log(this.posterInfo);
    //      setCookie("TenantId", this.posterInfo.TenantID, expireDays);
    //   setCookie("PosterId", this.posterInfo.PosterId, expireDays);
    // }

    // if (this.WxQrCodePosterList) {
    //   setCookie("TenantId", this.WxQrCodePosterList.TenantID, expireDays);
    //   setCookie("WxQrCode", this.WxQrCodePosterList.PosterId, expireDays);
    //   setCookie("Aid", this.WxQrCodePosterList.Aid, expireDays);
    //   //this.seche();
    // }
    //EventName
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };

    //接收修改传来的数据

    // Bus.$on("PosterId", (Item: any) => {
    //   //this.BasicInformationData = Item;
    //   if (Item) {
    //     console.log(Item);
    //   }
    // });
    // Bus.$on("WxQrCode", (Item: any) => {
    //   //this.BasicInformationData = Item;
    //   if (Item) {
    //     // console.log(Item);
    //   }
    // });
    //活动基本信息
    Bus.$on("BasicInformationData", (Item: any) => {
      this.BasicInformationData = Item;
    });
    //背景图片
    Bus.$on("canvasBgImg", (Item: any) => {
      this.canvasBgImg = Item;
    });
    //效果图片
    Bus.$on("Effect", (Item: any) => {
      if (Item) {
        this.Effect = Item;
      }
    });
    //海报设置
    Bus.$on("posterSetData", (Item: any) => {
      this.posterSetData = Item;
      // console.log(this.BasicInformationData);
    });
    //高级设置
    Bus.$on("AdvancedSettingsData", (Item: any) => {
      this.AdvancedSettingsData = Item;
      // console.log(this.BasicInformationData);
    });
    //通知设置
    Bus.$on("notificationSettingsData", (Item: any) => {
      this.notificationSettingsData = Item;
      // console.log(this.BasicInformationData);
    });
  }
  //验证海报数据表是否存在数据
  async seche() {
    var _this = this;
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: this.WxQrCodePosterList
        }
      ]
    };
    var res = await httpApi.GetVerifyData(params);
    //console.log(res);
    if (res.ErrorCode == 0) {
      let data = res.output[0].value;
      // console.log(data);
      _this.posterInfo = data;
      //  getCookie("PosterId");
      // this.PosterId = data.PosterId;
      // let expireDays = 1000 * 60 * 60;
      // setCookie("PosterId", data.PosterId, expireDays);
    } else {
      this.$message.error("加载修改数据失败：" + res.ErrorMessage);
    }
  }
  //取消方法
  cancle() {
    this.$emit("formData", {
      pagename: "listForm",
      WxQrCodePosterList: [],
      WxQrCodePosterDetail: {},
      page: 1
    });
  }
  //保存数据
  async saveData() {
    let _this = this;
    //console.log("保存数据");
    //console.log("活动基本信息:" + JSON.stringify(this.BasicInformationData));
    // console.log("海报编辑:" + JSON.stringify(this.posterSetData));
    // console.log("高级设置:" + JSON.stringify(this.AdvancedSettingsData));
    // console.log("通知设置:" + JSON.stringify(this.notificationSettingsData));
    // console.log("背景图片:" + this.canvasBgImg);
    //验证数据
    if (!this.BasicInformationData) {
      this.$message.warning("保存失败：请完善活动基本信息");
      this.activeName = "first";
      return;
    } else {
      if (!this.BasicInformationData.eventName) {
        this.$message.warning("保存失败：请完善活动名称");
        this.activeName = "first";
        return;
      }
      if (!this.BasicInformationData.group) {
        this.$message.warning("保存失败：请完善活动分组");
        this.activeName = "first";
        return;
      }
      if (!this.BasicInformationData.keyWords) {
        this.$message.warning("保存失败：请完善触发关键词");
        this.activeName = "first";
        return;
      }
      if (!this.BasicInformationData.activityTime) {
        this.$message.warning("保存失败：请选择活动开始结束时间");
        this.activeName = "first";
        return;
      }
      if (
        this.BasicInformationData.expirationDate.day == 0 &&
        this.BasicInformationData.expirationDate.hour == 0 &&
        this.BasicInformationData.expirationDate.minute == 0
      ) {
        this.$message.warning("保存失败：请选择海报有效时间");
        this.activeName = "first";
        return;
      }
    }
    if (!this.posterSetData) {
      this.$message.warning("保存失败：请完善海报编辑");
      this.activeName = "second";
      return;
    }
    if (!this.AdvancedSettingsData) {
      this.$message.warning("保存失败：请完善高级设置");
      this.activeName = "third";
      return;
    }
    if (!this.notificationSettingsData) {
      this.$message.warning("保存失败：请完善通知设置");
      this.activeName = "fourth";
      return;
    }
    if (!this.canvasBgImg) {
      this.$message.warning("保存失败：请上传海报背景图片！");
      this.activeName = "second";
      return;
    }
    //保存数据
    let id: any = localStorage.getItem("PosterDataId"); // getCookie("PosterId");
    let wxQrCode: any = localStorage.getItem("WxQrCode"); // getCookie("WxQrCode");
    let ActionName = "CREATE";
    if (id) {
      if (parseInt(id) > 0 || wxQrCode) ActionName = "UPDATE";
      //修改数据
      else {
        id = 0;
      }
    } else {
      id = 0;
    }
    let params: any = {
      Input: [
        {
          Name: "PromotePosterListDTO",
          Value: {
            ActionName: ActionName,
            //基本信息
            WxQrCode: wxQrCode,
            PosterId: id,
            TenantId: this.GetAppData.TenantID,
            Aid: this.GetAppData.Aid,
            EventName: this.BasicInformationData.eventName,
            Groups: this.BasicInformationData.group,
            KeyWords: this.BasicInformationData.keyWords,
            Reward: this.BasicInformationData.reward,
            EventStartTime: this.BasicInformationData.activityTime[0],
            EventEndTime: this.BasicInformationData.activityTime[1],
            PosterValidity: JSON.stringify(
              this.BasicInformationData.expirationDate
            ),
            Label: this.BasicInformationData.label,
            Status: this.BasicInformationData.Status,
            //海报参数
            BgImgWh: JSON.stringify(this.posterSetData.bgimg),
            BgImg: this.canvasBgImg, //海报背景
            Effect: this.Effect, //效果图片
            QrCode: JSON.stringify(this.posterSetData.qrcode),
            Complete: JSON.stringify(this.posterSetData.Complete),
            Avatar: JSON.stringify(this.posterSetData.avatar),
            Nickname: JSON.stringify(this.posterSetData.nickname),
            Reply: JSON.stringify(this.posterSetData.Reply),
            Regular: JSON.stringify(this.posterSetData.Regular),
            //高级设置
            Participate: JSON.stringify(this.AdvancedSettingsData.participate),
            Receive: JSON.stringify(this.AdvancedSettingsData.receive),
            AntiBrush: JSON.stringify(this.AdvancedSettingsData.antiBrush),
            //通知设置
            Notification: JSON.stringify(this.notificationSettingsData)
          }
        }
      ]
    };
    //console.log(params);
    this.loading = true;
    var res: any = await httpApi.GetSavePoster(params);
    this.loading = false;
    if (res.ErrorCode == 0) {
      this.$message.success("保存成功!");
      delCookie("PosterId");
      //保存成功后传个刷新方法过去
      _this.$emit("backtable");
      // this.cancle();
    } else {
      this.$message.error("保存失败：" + res.ErrorMessage);
    }
  }

  handleClick(tab: any, event: any) {
    //console.log(tab, event);
    // console.log(tab.name);

    //if()
    if (tab.name == "fives" || tab.name == "six") {
      this.buttonDisplay = false;
    } else {
      this.buttonDisplay = true;
    }
  }
}
